import { QuestionDetailsHeaderResponseJSON } from "./../questionPage/Question-Details-Header-Response.JSON";
import { QuestionCardResponseJSON } from "./../questionPage/Question-Card-Response.JSON";
import { SurveyDeployerWCPageRequestJSON } from "./../RequestTOJSON/Survey-Deployer-WC-Page-Request.JSON";

export class QuestionPageDetailsResponseJSON {
    surveyID: Number;
    questionDetailsHeaderResponseJSON: QuestionDetailsHeaderResponseJSON;
    questionCardResponseJSONList: QuestionCardResponseJSON[];
    surveyDeployerWCPageRequestJSON: SurveyDeployerWCPageRequestJSON;

    constructor() {
        this.questionDetailsHeaderResponseJSON = new QuestionDetailsHeaderResponseJSON;
        this.questionCardResponseJSONList = new Array<QuestionCardResponseJSON>();
    }
}